import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {CitySlug} from "../../../../../config/cities";
import {IRootState} from "../../../store/store";

/** City-level context saved before drilling into a district on the map. */
export interface IChartsMapParentRegion {
    isRouteCity: boolean;
    regionId: number;
    slug: string;
    citySlug: CitySlug | null;
    label: string;
    hasChartsAccess: boolean;
    regionsMapSlug?: string;
    regionsMapParentId?: number;
    regionsMapRegionId?: number;
    regionsMapChildType?: number;
}

export interface IChartsSelectedRegion {
    regionId: number;
    slug: string;
    citySlug: CitySlug | null;
    label: string;
    hasChartsAccess: boolean;
    regionsMapSlug?: string;
    regionsMapParentId?: number;
    regionsMapRegionId?: number;
    regionsMapChildType?: number;
    parentRegion?: IChartsMapParentRegion;
}

export interface IMapCityPocState {
    /** `city=` for cbi-map + region polygons; `null` → route city in `LeafletMap`. */
    cityQuery: string | null;
    /** Explicit charts region override — set only from region select (not while typing). */
    chartsSelectedRegion: IChartsSelectedRegion | null;
}

const initialState: IMapCityPocState = {
    cityQuery: null,
    chartsSelectedRegion: null
};

export const mapCityPocSlice = createSlice({
    name: "mapCityPoc",
    initialState,
    reducers: {
        setMapCityPocCityQuery: (state, action: PayloadAction<string | null>) => {
            const trimmed = action.payload?.trim() ?? "";
            state.cityQuery = trimmed.length > 0 ? trimmed : null;
        },
        setChartsSelectedRegion: (state, action: PayloadAction<IChartsSelectedRegion | null>) => {
            state.chartsSelectedRegion = action.payload;
        },
        clearChartsRegionPoc: (state) => {
            state.cityQuery = null;
            state.chartsSelectedRegion = null;
        }
    }
});

export const {setMapCityPocCityQuery, setChartsSelectedRegion, clearChartsRegionPoc} = mapCityPocSlice.actions;

export const selectMapCityPocCityQuery = (state: IRootState) => state.mapCityPoc.cityQuery;
export const selectChartsSelectedRegion = (state: IRootState) => state.mapCityPoc.chartsSelectedRegion;
